<template>
    <modal-form v-model="show" size="md" :key="codigoProposta" :show-submit="false">
        <template v-slot:title>
            Comprovante de Pagamento
        </template>
        <template v-slot:body>
            <core-grid ref="grid" modal flat :onRead="onRead" :schema="schema" hide-all-options>
                <template v-slot:[`item.Arquivo`]="{ item }">
                    <v-icon class="ml-7" size="dense" @click="downloadComprovante(item)">
                        fas fa-file-download
                    </v-icon>
                    <a @click="downloadComprovante(item)"></a>
                </template>
            </core-grid>
        </template>
    </modal-form>
</template>
<script>

export default {

  props: {
    codigoProposta: null
  },
  data () {
    return {
      show: false,
      schema: [
        { value: 'NomeFavorecido', text: 'Beneficiário' },
        { value: 'Valor', text: 'Valor (R$)', format: 'currency' },
        { value: 'Arquivo', text: 'Comprovante' }
      ],
    }
  },
  methods: {
    openModal () {
      this.show = true
    },
    onRead: function (options, search) {
      const th = this
      if (th.codigoProposta) {
        th.$api.Multiplo.ListRemessaPagamentoDetalhesPagosPorCodigoProposta({ guidID: th.codigoProposta }).then((response) => {
          if (th.$api.UI.PostLoadData(response)) {
            options.success(response.Data);
          }
        })
      } else {
        options.success([]);
      }
    },
    downloadComprovante (current) {
      this.$api.Multiplo.GerarComprovantePagamento(current.CodigoDetalhe)
    }
  }
}

</script>
